import { useEffect, useRef } from "react"
import { useModuleContext } from "contexts/ModuleContext"
import { useStudentHub } from "contexts/StudentHubContext"
import { DEVICE_TYPES, SCREEN_ID } from "common/constants"
import { ACTIVITY_VIEW_MODES } from "pages/student/activity/common/constants"

const getScreenId = (screenName) => {
  const deviceTypeId = DEVICE_TYPES.WEB
  return SCREEN_ID[deviceTypeId][screenName]
}

export const useStudentActivityTracker = () => {
  const { module, exercise, activity, viewMode, loadingContent } = useModuleContext()
  const { setSessionActivityLog, setAllowShowNotification, notificationData } = useStudentHub()
  const sessionRef = useRef()

  useEffect(() => {
    const exerciseId = exercise?.exerciseId
    const missionsActivityId = activity?.missionsActivityId
    if (
      !loadingContent &&
      exerciseId > 0 &&
      (missionsActivityId > 0 ||
        viewMode === ACTIVITY_VIEW_MODES.PLACEMENT_TEST) &&
      (viewMode === ACTIVITY_VIEW_MODES.STUDENT ||
        viewMode === ACTIVITY_VIEW_MODES.PLACEMENT_TEST) &&
      (exerciseId !== sessionRef?.current?.exerciseId ||
        missionsActivityId !== sessionRef?.current?.missionsActivityId ||
        viewMode !== sessionRef?.current?.view)
    ) {
      sessionRef.current = {
        exerciseId,
        missionsActivityId,
        view: viewMode,
      }
      setSessionActivityLog({
        exerciseId,
        missionsActivityId,
        viewId: getScreenId(
          viewMode === ACTIVITY_VIEW_MODES.PLACEMENT_TEST
            ? "placement"
            : "default"
        ),
      })
    }
  }, [
    exercise?.exerciseId,
    activity?.missionsActivityId,
    viewMode,
    loadingContent,
    setSessionActivityLog,
  ])

  useEffect(() => {
    if (
      !notificationData?.independentWork?.missionModuleId
    ) {
      setAllowShowNotification(true)
      return
    }
    if (
      module?.missionModuleId ===
      notificationData?.independentWork?.missionModuleId
    ) {
      setAllowShowNotification(false)
    } else {
      setAllowShowNotification(true)
    }
  }, [
    module?.missionModuleId,
    notificationData?.independentWork?.missionModuleId,
    setAllowShowNotification,
  ])
}

export default useStudentActivityTracker
